import Glide from '@glidejs/glide';
import $ from 'jquery';

$(() => {
    if($('.js-glide').length > 0) {
        new Glide('.js-glide', {
            type: 'carousel',
            //startAt: 0,
            focusAt: 'center',
            perView: 3,
            breakpoints: {
                800: {
                    perView: 1
                }
            }
        }).mount();
    }
    if($('.js-glide-single').length > 0) {
        new Glide('.js-glide-single', {
            type: 'carousel',
            //startAt: 0,
            //focusAt: 'center',
            perView: 1,
        }).mount();
    }
});